import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { EInspectionStepUrl } from 'src/app/interfaces/PWA/Inspection';
import { OrientationService } from 'src/app/services/General/Orientation/orientation.service';

@Injectable({
  providedIn: 'root',
})
export class InspectionOrientationResolverService implements Resolve<any> {

  constructor(
    private readonly orientationService: OrientationService
  ) {}

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any> {
    const url = state.url.split('?')[0];
    const landscapeUrls = [
      EInspectionStepUrl.Photo,
    ]
    const orientationType: OrientationType = landscapeUrls.includes(url as EInspectionStepUrl) ? 'landscape-primary' : 'portrait-primary';  
    this.orientationService.lockScreen(orientationType);
  }
}
